import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

interface DeleteLineItemParams {
  invoiceId: string;
  type: string;
}

export const deleteLineItem = async ({
  invoiceId,
  type,
}: DeleteLineItemParams) => {
  const response = await baseAPI.delete<unknown>(
    `subscription-invoices/delete-line-item/${invoiceId}`,
    {
      data: { productName: type },
    },
  );
  return response.data;
};

export const useDeleteLineItemMutation = () => {
  return useMutation({
    mutationFn: (params: DeleteLineItemParams) => deleteLineItem(params),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        predicate: (query) =>
          query.queryKey[0] === KEYS.STUDENT_PAYMENT_HISTORY,
      });
      // Line-item changes alter invoice outstanding → refresh Dashboard V2 AR
      void queryClient.invalidateQueries({ queryKey: [KEYS.ACCOUNTS_RECEIVABLE] });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ACCOUNTS_RECEIVABLE_DUE_DATE_GROUPING],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ACCOUNTS_RECEIVABLE_STUDENT_GROUPING],
      });
    },
  });
};
